import React from 'react';

import useTranslation from 'src/hooks/use-translation';
import useProductQueryParams from 'src/hooks/use-product-query-params';
import Section from 'src/components/sidebar-filters/section';
import { CheckboxGroup } from 'src/components/core';

type CustomSmartTagFilterProps = {
  smartTags: string[];
  title?: string;
};

export function CustomSmartTagFilter({ smartTags, title }: CustomSmartTagFilterProps): JSX.Element {
  const { t } = useTranslation();
  const { defaults, queryParams, setQueryParams } = useProductQueryParams();
  const currentSmartTags = queryParams.smartTags;

  const tagOptions = smartTags.map((tag) => ({ key: tag, label: tag, value: tag }));

  const handleOptionClick = (tagValue: string): void => {
    const tagsSet = new Set(currentSmartTags);

    if (tagsSet.has(tagValue)) {
      tagsSet.delete(tagValue);
    } else {
      tagsSet.add(tagValue);
    }

    setQueryParams({
      smartTags: Array.from(tagsSet),
      page: defaults.page,
    });
  };

  return (
    <Section startsOpen heading={title || t('common.tag_plural', 'Tags')}>
      <CheckboxGroup options={tagOptions} selectedOptions={currentSmartTags} onSelect={handleOptionClick} />
    </Section>
  );
}
